module.exports = __webpack_public_path__ + "static/the-friends-of-eddie-coyle-fd5eb6a9ba3486beee88e2c3d98d68d1.jpg";